import { render, staticRenderFns } from "./UserService.vue?vue&type=template&id=1efa60cc&scoped=true"
import script from "./UserService.vue?vue&type=script&lang=js"
export * from "./UserService.vue?vue&type=script&lang=js"
import style0 from "./UserService.vue?vue&type=style&index=0&id=1efa60cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efa60cc",
  null
  
)

export default component.exports